import { useRef, useState } from "react";
import { Move } from "lucide-react";

export function CoverReposition({ src, position = "50% 50%", onChange }) {
  const ref = useRef(null);
  const [drag, setDrag] = useState(false);

  const update = (clientX, clientY) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    let x = ((clientX - r.left) / r.width) * 100;
    let y = ((clientY - r.top) / r.height) * 100;
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));
    onChange(`${Math.round(x)}% ${Math.round(y)}%`);
  };
  const pt = (e) => (e.touches && e.touches[0]) ? e.touches[0] : e;
  const onDown = (e) => { setDrag(true); const p = pt(e); update(p.clientX, p.clientY); };
  const onMove = (e) => { if (!drag) return; const p = pt(e); update(p.clientX, p.clientY); };
  const onUp = () => setDrag(false);

  return (
    <div className="space-y-1.5">
      <div
        ref={ref}
        data-testid="cover-reposition"
        onMouseDown={onDown} onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}
        onTouchStart={onDown} onTouchMove={onMove} onTouchEnd={onUp}
        className="relative w-full max-w-sm aspect-video rounded-lg border border-white/10 overflow-hidden cursor-move select-none"
      >
        <img src={src} alt="Anteprima copertina" draggable={false} className="w-full h-full object-cover pointer-events-none" style={{ objectPosition: position }} />
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 pointer-events-none">
          <span className="text-[11px] bg-black/65 text-white px-2 py-1 rounded-full inline-flex items-center gap-1"><Move className="w-3 h-3" /> Trascina per inquadrare</span>
        </div>
      </div>
      <button type="button" data-testid="cover-reposition-reset" onClick={() => onChange("50% 50%")} className="text-xs text-muted-foreground hover:text-gold">Centra immagine</button>
    </div>
  );
}
